import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as evaluationComplete from './evaluation-complete'
import * as evaluationIncomplete from './evaluation-incomplete'

export const DOC = gql`
  ${evaluationComplete.DOC}
  ${evaluationIncomplete.DOC}
  fragment FragmentQuiverEvaluation on QuiverEvaluation {
    __typename
    ...FragmentQuiverEvaluationComplete
    ...FragmentQuiverEvaluationIncomplete
  }
`
export const TRANSFORMER = graphql.transformers.OUT.discriminateOn<
  graphql.schema.FragmentQuiverEvaluationFragment,
  ents.core.quiver.Evaluation,
  '__typename'
>('__typename', {
  QuiverEvaluationComplete: evaluationComplete.TRANSFORMER,
  QuiverEvaluationIncomplete: evaluationIncomplete.TRANSFORMER,
})
